import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormDecorationField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'color-field-component',
    templateUrl: './color-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class DtypeColorFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormDecorationField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
